import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import instance from "../Config/Config";
import { FaRegCopy } from "react-icons/fa";

import toast from "react-hot-toast";
// import {Modal} from 'bootstrap'

const OrderDetailPage = () => {
  const location = useLocation();
  const orderData1 = location.state?.orderData;
  const [spinner, setspinner] = useState(false);
  const [isloading, setIsloading] = useState(true);

  const [orderData, SetorderData] = useState(orderData1 ? orderData1 : "");
  const [cartdata, setCartData] = useState();
  const [request, setRequest] = useState(false)




  //changed
  const [cancelSubmitted, setCancelSubmitted] = useState(false);



  const GetCheckoutList = async () => {
    setIsloading(true);
    try {
      const responseApi = await instance.get(
        `my_order_details/${orderData.id}`
      );


      setCartData(responseApi?.data?.order);
      SetorderData(responseApi?.data?.order);
      setIsloading(false);
    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );
      setIsloading(true);
    }
  };

  useEffect(() => {
    GetCheckoutList();
  }, []);

  const router = useNavigate();

  const handleCheckoutClick = (e) => {
    e.preventDefault();
    document.getElementById("payment-pup").click();
  };

  const [cancelReason, setCancelReason] = useState("");
  const [error, setError] = useState("");

  // const handleOrdercancel = async (e) => {
  //   e.preventDefault();

  //   if (!cancelReason.trim()) {
  //     setError("Please enter a reason for cancellation.");
  //     return;
  //   }
  //   setError("");
  //   setIsloading(true);

  //   try {
  //     const order_id = orderData.id;
  //     const reason = "Customer cancelled";

  //     const responseApi = await instance.post("cancel_request", {
  //       order_id,
  //       reason: cancelReason.trim(),
  //     });
  //     setCancelReason("");
  //     setIsloading(false);
  //     // window.location.reload();
  //   } catch (error) {
  //     console.error(
  //       "Error while sending cancel request:",
  //       error.response?.data || error.message
  //     );
  //     // window.location.reload();
  //     setIsloading(false); // Also stop spinner on error
  //   }
  // };

  // const handleOrdercancel = async () => {
  //   if (!cancelReason.trim()) {
  //     setError("Please enter a reason for cancellation.");
  //     return;
  //   }

  //   try {
  //     setIsloading(true);
  //     await instance.post("cancel_request", {
  //       order_id: orderData.id,
  //       reason: cancelReason.trim(),
  //     });

  //     setCancelReason("");
  //     setIsloading(false);
  //     setCancelSubmitted(true);
  //     toast.success("Cancel request sent");

  //     const modalEl = document.getElementById("paymentbox");
  //     let modal = Modal.getInstance(modalEl);
  //     if (!modal) {
  //       modal = new Modal(modalEl);
  //     }
  //     modal.hide();

  //     // Manually remove backdrop & body class if still present (optional)
  //     const backdrops = document.getElementsByClassName("modal-backdrop");
  //     while (backdrops.length > 0) {
  //       backdrops[0].parentNode.removeChild(backdrops[0]);
  //     }
  //     document.body.classList.remove("modal-open");
  //     document.body.style.paddingRight = "";
  //   } catch (error) {
  //     setIsloading(false);
  //     toast.error("Request failed");
  //     console.error(error);
  //   }
  // };



  const handleOrdercancel = async (e) => {
    e.preventDefault();

    if (!cancelReason.trim()) {
      setError("Please enter a reason for cancellation.");
      return;
    }
    setError("");
    setIsloading(true);

    try {
      const order_id = orderData.id;

      await instance.post("cancel_request", {
        order_id,
        reason: cancelReason.trim(),
      });

      setCancelReason("");
      setIsloading(false);
      toast.success("Cancel request sent")
      document.getElementById("payment-pup").click();
      setRequest(true)
      setCancelSubmitted(true);


      //cancel model

      // Mark cancel submitted
    } catch (error) {
      console.error(
        "Error while sending cancel request:",
        error.response?.data || error.message,
        toast.error("request failed"),
        setRequest(false)
      );
      setIsloading(false);
    }
  };



  //   const handleOrdercancel = async (e) => {
  //   e.preventDefault();

  //   // Validate cancel reason input
  //   if (!cancelReason.trim()) {
  //     setError("Please enter a reason for cancellation.");
  //     return;
  //   }

  //   setError("");
  //   setIsloading(true);

  //   try {
  //     const order_id = orderData.id;

  //     // Send cancel request with the reason provided by user
  //     const responseApi = await instance.post("cancel_request", {
  //       order_id,
  //       reason: cancelReason.trim(),
  //     });

  //     // Clear the input and loading state after success
  //     setCancelReason("");
  //     setIsloading(false);

  //     // Optionally reload or update UI here
  //     // window.location.reload();
  //   } catch (error) {
  //     console.error(
  //       "Error while sending cancel request:",
  //       error.response?.data || error.message
  //     );

  //     // Optionally show an error to user here (if you have a state for it)

  //     setIsloading(false); // Stop spinner on error
  //   }
  // };



  let shipping = {};
  try {
    shipping = JSON.parse(orderData?.shipping_address || "{}");
  } catch (error) {
    console.error("Invalid shipping address JSON");
  }
  return (
    <div className="container mt-5 mb-5 pt-3">
      <section>
        <div className="container mt-5 " data-aos="f">
          <div className="row">
            <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12 mt-3">
              <div className="d-flex justify-content-center contact-form2 mb-3">
                <form className="">
                  <div className="row">
                    <h6
                      style={{
                        color: "#972734",
                        fontWeight: "bold",
                      }}
                      className="mb-3 text-center"
                    >
                      <b> SHIPPING ADDRESS</b>
                    </h6>
                    <hr />

                    {orderData ? (
                      <div className="col-12">
                        <div className="d-flex justify-content-between">
                          <p>
                            <strong>Name:</strong>{" "}
                          </p>
                          <p> {shipping.name}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p>
                            <strong>Address:</strong>{" "}
                          </p>
                          <p className="text-end"> {shipping.address},{shipping.state},{shipping.city},{shipping.country}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                          <p>
                            <strong>Postal Code:</strong>{" "}
                          </p>
                          <p> {shipping.postal_code}</p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-danger">Order details not found.</p>
                    )}
                  </div>

                  <div className="form-group d-flex justify-content-end"></div>
                </form>
              </div>

              {((orderData?.delivery_status == "on_the_way" || orderData?.delivery_status == "delivered") && orderData?.logistic) && <div className="d-flex justify-content-center contact-form2 mb-3">
                <form className="">
                  <div className="row">
                    <h6
                      style={{
                        color: "#972734",
                        fontWeight: "bold",
                      }}
                      className="mb-3 text-center"
                    >
                      <b> COURIER SERVICE</b>
                    </h6>
                    <hr />

                    {/* {orderData ? (
                      <>
                        

                      
                        {orderData?.logistic && 
                          <div className="col-12">
                            <h6 className="mb-2" style={{ color: "#972734", fontWeight: "bold" }}>
                              <b>Logistics</b>
                            </h6>
                            {orderData?.logistic.map((logistic, idx) => (
                              <div
                                key={idx}
                                className="d-flex align-items-center justify-content-between p-2 mb-2 border rounded"
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <img
                                    src={logistic.logo} 
                                    alt={logistic.name}
                                    style={{ width: "40px", height: "40px", objectFit: "contain" }}
                                  />
                                  <span style={{ fontWeight: 500 }}>{logistic.name}</span>
                                </div>
                                <a
                                  href={logistic.tracking_link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-outline-primary"
                                >
                                  Track
                                </a>
                              </div>
                            ))}
                          </div>
                        }
                      </>
                    ) : (
                      <p className="text-danger">Order details not found.</p>
                    )} */}
                    {orderData?.logistic && (
                      <div className="col-12">


                        {Array.isArray(orderData.logistic) ? (
                          orderData.logistic.map((logistic, idx) => (
                            <div
                              key={idx}
                              className="d-flex align-items-center justify-content-between p-2 mb-2 border rounded"
                            >

                              <div className="d-flex align-items-center gap-2">
                                <img
                                  src={logistic.logo}
                                  alt={logistic.name}
                                  style={{ width: "40px", height: "40px", objectFit: "contain" }}
                                />
                                <span style={{ fontWeight: 500 }}>{logistic.name}</span>
                              </div>


                              <a
                                href={logistic.tracking_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary"
                              >
                                Track
                              </a>
                            </div>
                          ))
                        ) : (

                          <div className="d-flex align-items-center justify-content-between p-2 mb-2 border rounded">


                            <div className="d-flex align-items-center gap-3">


                              <div className="d-flex align-items-center gap-2">
                                <img
                                  src={orderData.logistic.logo}
                                  alt={orderData.logistic.name}
                                  style={{ width: "50px", height: "50px", objectFit: "contain" }}
                                />
                                <div className="d-flex flex-column">
                                  <span style={{ fontWeight: 500 }}>{orderData.logistic.name}</span>
                                  {orderData?.tracking_id && (
                                    <div className="d-flex align-items-center gap-2">

                                      <div
                                        className="d-flex align-items-center gap-2"
                                        style={{
                                          background: "#f3e8e8",
                                          padding: "4px 8px",
                                          borderRadius: "5px",
                                          fontWeight: 600,
                                          fontSize: "14px",
                                          color: "#972734",
                                          cursor: "pointer",
                                          userSelect: "none",
                                          transition: "0.2s",
                                        }}
                                        onClick={async () => {
                                          await navigator.clipboard.writeText(orderData.tracking_id);
                                          toast.success("Tracking ID copied!");
                                        }}
                                        onMouseEnter={(e) => (e.target.style.background = "#e7d4d4")}
                                        onMouseLeave={(e) => (e.target.style.background = "#f3e8e8")}
                                      >
                                        {/* ID */}
                                        <span>Tracking Id:{orderData.tracking_id}</span>

                                        {/* Copy Icon */}
                                        <FaRegCopy size={14} />
                                      </div>

                                    </div>
                                  )}
                                </div>

                                <br />




                              </div>






                            </div>


                            {/* Track button */}
                            <a
                              href={orderData.logistic.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-outline-primary"
                            >
                              Track
                            </a>
                          </div>
                        )}

                      </div>
                    )}


                  </div>
                </form>
              </div>
              }

              <div className="d-flex justify-content-center contact-form2">
                <form className="">
                  <div className="row">
                    <h6
                      style={{
                        color: "#972734",
                        fontWeight: "bold",
                      }}
                      className="mb-3 text-center"
                    >
                      <b>ORDER DETAILS</b>
                    </h6>
                    <hr />

                    {orderData ? (
                      <div className="col-12">

                        <div className="d-flex justify-content-between">
                          <p>
                            <strong>Sub Total:</strong>{" "}
                          </p>
                          <p>
                            {Number(orderData.subtotal).toLocaleString('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            })}
                          </p>
                          {/* <p> ₹{Number(orderData.tax).toFixed(2)}</p> */}
                        </div>


                        <div className="d-flex justify-content-between">
                          <p>
                            <strong>GST:</strong>{" "}
                          </p>
                          <p>
                            {Number(orderData.tax).toLocaleString('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            })}
                          </p>
                          {/* <p> ₹{Number(orderData.tax).toFixed(2)}</p> */}
                        </div>





                        <div className="d-flex justify-content-between">
                          <p>
                            <strong>Shipping:</strong>{" "}
                          </p>
                          <p>
                            {Number(orderData.shipping_cost).toLocaleString('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                              minimumFractionDigits: 2,
                            })}
                          </p>
                          {/* <p> ₹{Number(orderData.tax).toFixed(2)}</p> */}
                        </div>



                        



                        <hr style={{
                          border: "none",
                          borderTop: "2px dashed red",
                          marginTop: "2px"
                        }} />





                        <div className="d-flex justify-content-between">
                          <p><strong>Total Amount:</strong></p>
                          <p>
                            {Number(
                              (orderData?.shipping_cost ?? 0) +
                              (orderData?.tax ?? 0) +
                              (orderData?.subtotal ?? 0)
                            ).toLocaleString("en-IN", {
                              style: "currency",
                              currency: "INR",
                              minimumFractionDigits: 2,
                            })}
                          </p>
                        </div>
                          {orderData?.special_discount > 0 && (
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <p className="mb-0">
                              <b>Silver Discount</b>
                            </p>

                            <p className="mb-0 text-success">
                              <b>
                                (-) {Number(orderData?.special_discount).toLocaleString("en-IN", {
                                  style: "currency",
                                  currency: "INR",
                                  minimumFractionDigits: 2,
                                })}
                              </b>
                            </p>
                          </div>
                        )}




                        {(
                          (orderData?.coupon_discount ?? 0) !== 0 ||
                          (orderData?.wallet_amount ?? 0) !== 0
                        ) && (
                            <hr
                              style={{
                                border: "none",
                                borderTop: "2px dashed red",
                                marginTop: "2px",
                              }}
                            />
                          )}



                        {orderData.coupon_discount != null && orderData.coupon_discount != 0 && (
                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>Discount:</strong>{" "}
                            </p>
                            <p className="text-danger">
                              - {Number(orderData.coupon_discount).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                                minimumFractionDigits: 2,
                              })}
                            </p>
                            {/* <p> ₹{Number(orderData.tax).toFixed(2)}</p> */}
                          </div>
                        )}

                        {orderData.wallet_amount != null && orderData.wallet_amount !== 0 && (
                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>Wallet:</strong>{" "}
                            </p>
                            <p className="text-danger">
                              - {Number(orderData.wallet_amount).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                                minimumFractionDigits: 2,
                              })}
                            </p>
                          </div>
                        )}

                        {orderData.redeem_coupon != null && orderData.redeem_coupon !== 0 && (
                          <div className="d-flex justify-content-between">
                            <p>
                              <strong>Gift Code:</strong>{" "}
                            </p>
                            <p className="text-danger">
                              - {Number(orderData.redeem_coupon).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                                minimumFractionDigits: 2,
                              })}
                            </p>
                          </div>
                        )}
                        <hr style={{
                          border: "none",
                          borderTop: "2px dashed red",
                          marginTop: "2px"
                        }} />
                        <div className="d-flex justify-content-between">
                          <p>
                            <strong>
                              {orderData?.payment_type === "wallet" ? "Payable Type:" : "Payable Amount:"}
                            </strong>{" "}
                          </p>
                          <p>
                            {orderData?.payment_type === "wallet" &&
                              Number(orderData?.grand_total) <= 0 ? (
                              <span>Wallet Used</span>
                            ) : (
                              `₹${Number(orderData?.grand_total || 0).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`
                            )}
                          </p>


                          {/* <p> ₹{Number(orderData.grand_total).toFixed(2)}</p> */}
                        </div>



                      </div>
                    ) : (
                      <p className="text-danger">Order details not found.</p>
                    )}


                    {/* {
              // orderData?.cancel_request === true && (
              //    <button
              //         className="text-white btn btn-danger"
              //         onClick={handleCheckoutClick}
              //       >
              //         {spinner ? (
              //           <span
              //             className="spinner-border spinner-border-sm"
              //             role="status"
              //           ></span>
              //         ) : (
              //           <b>
              //             Order Cancel <span className="ms-2"></span>
              //           </b>
              //         )}
              //       </button>
              // )           
              } */}
                    {/* {orderData?.cancel_request === true && (
                      <button
                        className="text-white btn btn-danger"
                        onClick={handleCheckoutClick}
                        disabled={cancelSubmitted || spinner || orderData?.cancel_request === "true"}
                      >
                        {spinner ? (
                          <span className="spinner-border spinner-border-sm" role="status"></span>
                        ) : (
                          <b> {orderData.cancel_request == "true" ? "Order Requested for Cancel" : "ncel"}<span className="ms-2"></span></b>
                        )}
                      </button>
                    )} */}



                    {/* {orderData.delivery_status !== "cancelled" && orderData.status === "confirmed" && (
                      <button
                        className="text-white btn btn-danger"
                        onClick={handleCheckoutClick}
                        disabled={cancelSubmitted || spinner || orderData?.cancel_request != true}
                      >
                        {spinner ? (
                          <span className="spinner-border spinner-border-sm" role="status"></span>
                        ) : (
                          <b>
                            {orderData.cancel_request != true ? "Already Requested" : "Cancel Request"}
                          </b>
                        )}
                      </button>
                    )} */}

                    {/* {!(orderData.delivery_status === "cancelled" || orderData.delivery_status === "confirmed") && (
                      <button
                        className="text-white btn btn-danger"
                        onClick={handleCheckoutClick}
                        disabled={cancelSubmitted || spinner || orderData?.cancel_request === false}
                      >
                        {spinner ? (
                          <span className="spinner-border spinner-border-sm" role="status"></span>
                        ) : (
                          <b>
                            {orderData?.cancel_request ? "Cancel Request" : "Already Requested"}
                          </b>
                        )}
                      </button>
                    )} */}

                    {orderData.delivery_status === "pending" && (
                      <button
                        className="text-white btn btn-danger"
                        onClick={handleCheckoutClick}
                        disabled={cancelSubmitted || spinner || orderData?.cancel_request === false}
                      >
                        {spinner ? (
                          <span className="spinner-border spinner-border-sm" role="status"></span>
                        ) : (
                          <b>
                            {orderData?.cancel_request ? "Cancel Request" : "Already Requested"}
                          </b>
                        )}
                      </button>
                    )}






                  </div>
                </form>
              </div>
              <section>
                <button
                  type="button"
                  className="btn btn-primary d-none"
                  data-bs-toggle="modal"
                  data-bs-target="#paymentbox"
                  id="payment-pup"
                >
                  Launch Modal
                </button>

                <div
                  className="modal fade"
                  id="paymentbox"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      {/* Modal Header */}
                      <div className="modal-header">
                        <h5 className="modal-title">Confirm Cancellation</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="mb-3">
                          <label htmlFor="cancelReason" className="form-label">
                            Reason for cancellation{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <textarea
                            id="cancelReason"
                            className="form-control"
                            rows="3"
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                            placeholder="Enter your reason here..."
                          ></textarea>
                          {error && (
                            <div className="text-danger mt-1">
                              <small>{error}</small>
                            </div>
                          )}
                        </div>

                        <div className="d-flex justify-content-end gap-2">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleOrdercancel}
                          >
                            Yes, Cancel Order
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12 mt-3">
              <div className="d-flex justify-content-center contact-form2 ">
                <form className="">
                  <div className="row">
                    <h6
                      style={{
                        color: "#972734",
                        fontWeight: "bold",
                      }}
                      className="mb-3 text-center"
                    >
                      <b>PRODUCT DETAILS</b>
                    </h6>
                    <hr />

                    {isloading ? (
                      <div className="product-grid mb-3 mt-3">
                        <></>
                      </div>
                    ) : (
                      <div className="product-grid mb-3 mt-3">
                        {cartdata?.order_items?.length > 0 ? (
                          cartdata.order_items.map((item) => {
                            // console.log("Cart Item:", item); // <-- Console log each item here

                            return (
                              <div key={item.id} className="product-card">
                                <img
                                  src={item?.image} // double check this path
                                  alt={item.name}
                                  className="product-image"
                                />
                                <div className="product-info">
                                  <p className="product-name hidemanbyelp">
                                    {item.product.name}
                                  </p>
                                  <p className="product-name hidemanbyelp">
                                    Quantity: {item.qty}
                                  </p>
                                     <p className="product-name hidemanbyelp">Gram: {item.gram}</p>

                                     
                                  <p className="product-price">

                                    {Number(item.grand_total).toLocaleString('en-IN', {
                                      style: 'currency',
                                      currency: 'INR',
                                      minimumFractionDigits: 2,
                                    })}
                                    {/* ₹ {item.grand_total} */}
                                  </p>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p className="text-center">Your cart is empty.</p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="d-flex justify-content-center contact-form2">
                    <form className="">
                      <div className="row">
                        <h6
                          style={{
                            color: "#972734",
                            fontWeight: "bold",
                          }}
                          className="mb-3 text-center"
                        >
                          <b>PAYMENT DETAILS</b>
                        </h6>
                        <hr />

                        {orderData ? (
                          <div className="col-12">


                            <div className="d-flex justify-content-between">
                              <p>
                                <strong>Order Code:</strong>
                              </p>
                              <p> {orderData.code}</p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p>
                                <strong>Status:</strong>
                              </p>
                              {/* <p> {orderData.delivery_status}</p> */}
                              <p>
                                {orderData?.delivery_status
                                  .split('_')
                                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                  .join(' ')}
                              </p>

                            </div>
                            <div className="d-flex justify-content-between">
                              <p>
                                <strong>Payment Status:</strong>{" "}
                              </p>

                              <p> {orderData.payment_status}</p>
                            </div>
                            <div className="d-flex justify-content-between">
                              <p>
                                <strong>Payment Type:</strong>{" "}
                              </p>
                              <p>
                                {orderData?.payment_type === "razor_pay"
                                  ? "Razor pay"
                                  : orderData?.payment_type === "wallet"
                                    ? "Wallet"
                                    : "-"}
                              </p>

                              {/* <p> {orderData.payment_type}</p> */}
                            </div>




                            <div className="d-flex justify-content-between">
                              <p>
                                <strong>Order Date:</strong>{" "}
                              </p>
                              <p>
                                {new Date(orderData.created_at).toLocaleString()}
                              </p>
                            </div>
                          </div>
                        ) : (
                          <p className="text-danger">Order details not found.</p>
                        )}


                        {/* {
              // orderData?.cancel_request === true && (
              //    <button
              //         className="text-white btn btn-danger"
              //         onClick={handleCheckoutClick}
              //       >
              //         {spinner ? (
              //           <span
              //             className="spinner-border spinner-border-sm"
              //             role="status"
              //           ></span>
              //         ) : (
              //           <b>
              //             Order Cancel <span className="ms-2"></span>
              //           </b>
              //         )}
              //       </button>
              // )           
              } */}
                        {/* {orderData?.cancel_request === true && (
                      <button
                        className="text-white btn btn-danger"
                        onClick={handleCheckoutClick}
                        disabled={cancelSubmitted || spinner || orderData?.cancel_request === "true"}
                      >
                        {spinner ? (
                          <span className="spinner-border spinner-border-sm" role="status"></span>
                        ) : (
                          <b> {orderData.cancel_request == "true" ? "Order Requested for Cancel" : "ncel"}<span className="ms-2"></span></b>
                        )}
                      </button>
                    )} */}

                        {/* 
{orderData.delivery_status != "cancelled"    && <button
  className="text-white btn btn-danger"
  onClick={handleCheckoutClick}
  disabled={cancelSubmitted || spinner || orderData?.cancel_request != true}
>
  {spinner ? (
    <span className="spinner-border spinner-border-sm" role="status"></span>
  ) : (
    <b>
     
         {orderData.cancel_request == true ? "Cancel request" : "Already Requested"}
        
      <span className="ms-2"></span>
    </b>
  )}
</button>} */}

                        {/* {orderData.delivery_status !== "cancelled" && orderData.status === "confirmed" && (
                      <button
                        className="text-white btn btn-danger"
                        onClick={handleCheckoutClick}
                        disabled={cancelSubmitted || spinner || orderData?.cancel_request != true}
                      >
                        {spinner ? (
                          <span className="spinner-border spinner-border-sm" role="status"></span>
                        ) : (
                          <b>
                            {orderData.cancel_request != true ? "Already Requested" : "Cancel Request"}
                          </b>
                        )}
                      </button>
                    )} */}






                        {/* {orderData?.cancel_request === true && (
  <button
    className="text-white btn btn-danger"
    onClick={handleCheckoutClick}
    disabled={cancelSubmitted || spinner || orderData?.cancel_request === true}
  >
    {spinner ? (
      <span className="spinner-border spinner-border-sm" role="status"></span>
    ) : (
      <b>
        {orderData.cancel_request ? "Order Requested for Cancel" : "Order Cancel"}
        <span className="ms-2"></span>
      </b>
    )}
  </button>
)} */}



                      </div>
                    </form>
                  </div>



                  <div className="form-group d-flex justify-content-end"></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrderDetailPage;
